import React, {useEffect} from 'react';
import withStyles from '@mui/styles/withStyles';
import {Box, Typography} from '@mui/material';
import BackIcon from '@mui/icons-material/ArrowBack';
import {useHistory} from 'react-router-dom';
import { useQuery } from "@apollo/client";
import { GET_GENERAL_TERMS } from 'queries/queries';
import { Padding } from '@mui/icons-material';

const BlackTextTypography = withStyles({
  root: {
    color: "#000000"
  }
})(Typography);

const styles = theme => ({
  // root: {
  //   color: '#fff',
  //   margin: 12,
  //   marginBottom: 80,
  //   backgroundColor: '#fff',
  //   borderRadius: '20px',
  //   padding: 12
  // },
  headingBox: {
    paddingTop: 120,
  },
  heading: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#000',
    marginLeft: 20,
  },
  body: {
    fontSize: 14,
    fontWeight: 100,
    color: '#000',
    marginTop: 10,
  },
  stepContainer: {
    marginTop: 20,
    marginLeft: 40,
  },
  step: {
    fontSize: 14,
    fontWeight: 'bold',
    color: '#000',
  },
  stepBody: {
    fontSize: 14,
    fontWeight: 200,
    color: '#000',
  },
  ruleImage: {
    height: 50,
  },
  submitButton: {
    marginTop: 40,
    fontSize: 16,
    pading: 20,
    fontWeight: 'bold',
    color: '#fff',
    backgroundColor: '#7FC5ED',
    width: '80%',
    borderRadius: 20,
  },
  backIcon: {
    zIndex: 200,
    position: 'absolute',
    left: 24,
    top: 40,
    color: '#fff',
  },
});

const Rules = ({classes}) => {
  let history = useHistory();
  useEffect(() => {
    const wrapper = document.querySelector('.scrollable');
    if (!wrapper) return;

    document.querySelector('.scrollable').addEventListener(
      'touchmove',
      function(event) {
        event.stopPropagation();
      },
      false,
    );
  });

  const generalTerms = useQuery(GET_GENERAL_TERMS, {
    fetchPolicy: "no-cache",
  });

  return (
    <>
      <div className="scrollable">
        <div className="profile-rules">
          <div className="profile-text-container">
            <div dangerouslySetInnerHTML={{ __html: generalTerms.data?.getGeneralTerms?.content }}></div>
          </div>
        </div>
      </div>
    </>
  );
};

export default withStyles(styles)(Rules);
